import React from 'react';
export function ProofBar() {
  return <div className="py-7 bg-negro-suave border-y border-[rgba(201,151,43,.15)]" data-id="element-336">
      <div className="container" data-id="element-337">
        <div className="flex justify-center gap-12 flex-wrap max-md:gap-6" data-id="element-338">
          <div className="text-center" data-id="element-339">
            <span className="font-playfair text-[2.2rem] font-black text-dorado-claro block leading-none max-sm:text-[1.7rem]" data-id="element-340">
              +4.000
            </span>
            <span className="text-[11px] tracking-[.1em] uppercase text-gris-texto mt-1 block" data-id="element-341">
              Estudiantes activos
            </span>
          </div>
          <div className="text-center" data-id="element-342">
            <span className="font-playfair text-[2.2rem] font-black text-dorado-claro block leading-none max-sm:text-[1.7rem]" data-id="element-343">
              4.8★
            </span>
            <span className="text-[11px] tracking-[.1em] uppercase text-gris-texto mt-1 block" data-id="element-344">
              Valoración promedio
            </span>
          </div>
          <div className="text-center" data-id="element-345">
            <span className="font-playfair text-[2.2rem] font-black text-dorado-claro block leading-none max-sm:text-[1.7rem]" data-id="element-346">
              12
            </span>
            <span className="text-[11px] tracking-[.1em] uppercase text-gris-texto mt-1 block" data-id="element-347">
              Capítulos profundos
            </span>
          </div>
          <div className="text-center" data-id="element-348">
            <span className="font-playfair text-[2.2rem] font-black text-dorado-claro block leading-none max-sm:text-[1.7rem]" data-id="element-349">
              7
            </span>
            <span className="text-[11px] tracking-[.1em] uppercase text-gris-texto mt-1 block" data-id="element-350">
              Días de garantía
            </span>
          </div>
        </div>
      </div>
    </div>;
}